// An upload is processed asynchronously (S3 → scan → clean bucket → confirm webhook → Document),
// so after uploading we poll a "has the documentId been created yet?" endpoint until it resolves.
// Shared by every message-attachment composer (contract dialog + SeV2 Q&A) so the loop isn't duplicated.
export const pollForUploadedDocumentId = async (
  fetchDocumentId: (uploadId: string) => Promise<string | null>,
  uploadId: string,
  attempts = 30,
  intervalMs = 1000,
): Promise<string | null> => {
  for (let i = 0; i < attempts; i++) {
    const documentId = await fetchDocumentId(uploadId);
    if (documentId) return documentId;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return null;
};
